function collectionWithTabs() {
  const cwts = document.querySelectorAll('.collections-with-tabs');

  cwts.forEach(cwt => {
    if (!cwt) return;

    const cwtNavigationItems = cwt.querySelectorAll('.tabs-navigation-item');
    const cwtNavigationSelect = cwt.querySelector('.tabs-navigation-select');
    const cwtList = cwt.querySelectorAll('.product-grid');

    const activateTab = (item) => {
      const tagid = item.dataset.tab || item.value;
      cwtNavigationItems.forEach(element => element.classList.remove('active'));
      cwtList.forEach(element => element.classList.remove('active'));

      cwt
        .querySelectorAll(`.tabs-navigation-item[data-tab="${tagid}"]`)
        .forEach(activeNavItem => activeNavItem.classList.add('active'));

      const tabElement = cwt.querySelector(`[data-tab-id="${tagid}"]`);
      if (tabElement) {
        tabElement.classList.add('active');
      }
    };

    cwtNavigationItems.forEach(item => {
      if (item.dataset.tabsBound === 'true') return;

      item.dataset.tabsBound = 'true';
      item.addEventListener('click', () => activateTab(item));
      item.addEventListener('keyup', event => {
        if (event.key === 'Enter' || event.key === ' ') activateTab(item);
      });
    });

    if (cwtNavigationSelect && cwtNavigationSelect.dataset.tabsBound !== 'true') {
      cwtNavigationSelect.dataset.tabsBound = 'true';
      cwtNavigationSelect.addEventListener('change', () => activateTab(cwtNavigationSelect));
    }
  });
}

document.addEventListener('DOMContentLoaded', collectionWithTabs);
document.addEventListener('shopify:section:load', collectionWithTabs);
window.addEventListener('resize', collectionWithTabs);
